import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en, zh, th, vi } from '@motra/shared';

const savedLanguage = localStorage.getItem('motra_language') || 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
    th: { translation: th },
    vi: { translation: vi },
  },
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('motra_language', lng);
});

export default i18n;
